import axios from '@/services/axiosConfig'

const endPoint = {
	lookupStorageTreeAll: instId => `/institute/${instId}/storage/tree`,
	lookupStorageTree: (instId, storageId) =>
		`/institute/${instId}/storage/tree/target?id=${storageId}`,
	createStorage: instId => `/institute/${instId}/storage`,
	updateStorage: instId => `/institute/${instId}/storage`,
	deleteStorage: (instId, storageId) =>
		`/institute/${instId}/storage?id=${storageId}`,
	addUsingGroup: instId => `/institute/${instId}/location/groups`,
	lookupStorageInfo: (instId, storageId) => `/institute/${instId}/storage`,
	lookupWarningList: () => `/storage/warning/signs`,
	lookupLocationStorageTree: instId =>
		`/institute/${instId}/location/storage/tree`,
	lookupRootStorageList: instId => `/institute/${instId}/storage/list`,
}

const storageAPI = {
	lookupStorageTreeAll: instId =>
		axios.get(endPoint.lookupStorageTreeAll(instId)),
	lookupStorageTree: (instId, storageId) =>
		axios.get(endPoint.lookupStorageTree(instId, storageId)),
	createStorage: (instId, data) =>
		axios.post(endPoint.createStorage(instId), data),
	updateStorage: (instId, data) =>
		axios.put(endPoint.updateStorage(instId), data),
	deleteStroage: (instId, storageId) =>
		axios.delete(endPoint.deleteStorage(instId, storageId)),
	addUsingGroup: (instId, data) =>
		axios.put(endPoint.addUsingGroup(instId), data),
	lookupStorageInfo: (instId, storageId) =>
		axios.get(endPoint.lookupStorageInfo(instId), {
			params: { id: storageId },
		}),
	lookupWarningList: () => axios.get(endPoint.lookupWarningList()),
	lookupLocationStorageTree: instId =>
		axios.get(endPoint.lookupLocationStorageTree(instId)),
	lookupRootStorageList: instId =>
		axios.get(endPoint.lookupRootStorageList(instId)),
}

export default storageAPI
